import { useState } from 'react';
import { Text } from '@shopify/polaris';
import { formatToCurrency } from '../../../../shared/components/functions.jsx';
import { getAreasSorted } from '../../../../config/roasterySpec';

const deltaColor = (val) => (val > 0.005 ? '#27ae60' : val < -0.005 ? '#e74c3c' : '#666');
const deltaPrefix = (val) => (val > 0.005 ? '+' : '');

export default function DiffAreaDetail({ byArea }) {
  const [expanded, setExpanded] = useState({});

  if (!byArea || Object.keys(byArea).length === 0) return null;

  const toggle = (code) => setExpanded((prev) => ({ ...prev, [code]: !prev[code] }));

  // Sort areas by spec order, then any extras at the end
  const sortedCodes = getAreasSorted()
    .map((a) => a.code)
    .filter((c) => byArea[c]);
  const extraCodes = Object.keys(byArea).filter((c) => !sortedCodes.includes(c));
  const orderedCodes = [...sortedCodes, ...extraCodes];

  return (
    <div>
      <Text variant="headingSm" as="h3" fontWeight="semibold">
        Area Breakdown
      </Text>
      <div style={{ marginTop: '8px' }}>
        {/* Column headers */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 100px 100px', gap: '8px', borderBottom: '1px solid #e1e3e5', paddingBottom: '4px', marginBottom: '4px' }}>
          <Text variant="bodySm" as="span" tone="subdued" fontWeight="semibold">
            Area / Line
          </Text>
          <Text variant="bodySm" as="span" tone="subdued" fontWeight="semibold" alignment="end">
            Selling Delta
          </Text>
          <Text variant="bodySm" as="span" tone="subdued" fontWeight="semibold" alignment="end">
            Margin Delta
          </Text>
        </div>

        {orderedCodes.map((code) => {
          const area = byArea[code];
          const lineKeys = Object.keys(area.lines || {}).sort((a, b) => Number(a) - Number(b));
          const hasLines = lineKeys.length > 0;
          const isExpanded = expanded[code];

          return (
            <div key={code}>
              <div
                onClick={() => hasLines && toggle(code)}
                style={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 100px 100px',
                  gap: '8px',
                  padding: '4px 0',
                  cursor: hasLines ? 'pointer' : 'default',
                  alignItems: 'center'
                }}
              >
                <Text variant="bodySm" as="span" fontWeight="semibold">
                  {hasLines && <span style={{ fontSize: '10px', marginRight: '4px' }}>{isExpanded ? '\u25BC' : '\u25B6'}</span>}
                  {area.label}
                </Text>
                <Text variant="bodySm" as="span" fontWeight="semibold" alignment="end">
                  <span style={{ color: deltaColor(area.sellingDelta) }}>
                    {deltaPrefix(area.sellingDelta)}
                    {formatToCurrency(area.sellingDelta)}
                  </span>
                </Text>
                <Text variant="bodySm" as="span" fontWeight="semibold" alignment="end">
                  <span style={{ color: deltaColor(area.marginDelta) }}>
                    {deltaPrefix(area.marginDelta)}
                    {formatToCurrency(area.marginDelta)}
                  </span>
                </Text>
              </div>

              {isExpanded &&
                lineKeys.map((lineKey) => {
                  const line = area.lines[lineKey];
                  return (
                    <div key={lineKey} style={{ display: 'grid', gridTemplateColumns: '1fr 100px 100px', gap: '8px', padding: '2px 0', paddingLeft: '16px', alignItems: 'center' }}>
                      <Text variant="bodySm" as="span" tone="subdued">
                        {String(lineKey).padStart(3, '0')} {line.label}
                      </Text>
                      <Text variant="bodySm" as="span" tone="subdued" alignment="end">
                        <span style={{ color: deltaColor(line.sellingDelta) }}>
                          {deltaPrefix(line.sellingDelta)}
                          {formatToCurrency(line.sellingDelta)}
                        </span>
                      </Text>
                      <Text variant="bodySm" as="span" tone="subdued" alignment="end">
                        <span style={{ color: deltaColor(line.marginDelta) }}>
                          {deltaPrefix(line.marginDelta)}
                          {formatToCurrency(line.marginDelta)}
                        </span>
                      </Text>
                    </div>
                  );
                })}
            </div>
          );
        })}
      </div>
    </div>
  );
}
